import { render, staticRenderFns } from "./fs-pill-tag.vue?vue&type=template&id=5deab66a&scoped=true"
import script from "./fs-pill-tag.vue?vue&type=script&lang=js"
export * from "./fs-pill-tag.vue?vue&type=script&lang=js"
import style0 from "./fs-pill-tag.vue?vue&type=style&index=0&id=5deab66a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deab66a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5deab66a')) {
      api.createRecord('5deab66a', component.options)
    } else {
      api.reload('5deab66a', component.options)
    }
    module.hot.accept("./fs-pill-tag.vue?vue&type=template&id=5deab66a&scoped=true", function () {
      api.rerender('5deab66a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/pills/fs-pill-tag.vue"
export default component.exports